<div class="sidebar-body pt-0 data-scrollbar" [ngClass]="getSidebarClass()">
  <div class="sidebar-list">
    @if (navService.hasTree()) {
      <ul class="navbar-nav iq-main-menu" id="sidebar-menu">
        @for (navRoot of navService.getTree().getItems(); track navRoot.id) {
          @if (!navRoot.hasChildren()) {
            <li class="nav-item nav-root">
              <a class="nav-link" aria-current="page" [class.active]="navRoot.isSelected()"
                 (click)="selectAndNavigateByItem(navRoot)" (keydown.enter)="selectAndNavigateByItem(navRoot)" tabindex="0">
                <acc-icon [name]="navRoot.icon" class="nav-icon"/>
                <span class="item-name">{{ navRoot.title | translate }}</span>
              </a>
            </li>
          } @if (navRoot.hasChildren()) {
            <li class="nav-item nav-root">
              <div class="nav-link" aria-current="page" role="button"
                   [attr.data-bs-toggle]="!navRoot.isSelectedInTree() ? 'collapse' : undefined"
                   [class.active]="navRoot.isSelectedInTree()"
                   [attr.aria-controls]="navRoot.id"
                   [attr.aria-expanded]="navRoot.isSelectedInTree()"
                   [class.collapsed]="!navRoot.isSelectedInTree()"
                   (click)="selectAndNavigateByItem(navRoot)"
                   (keydown.enter)="selectAndNavigateByItem(navRoot)" tabindex="0">
                <acc-icon [name]="navRoot.icon" class="nav-icon"/>
                <span class="item-name">{{ navRoot.title | translate }}</span>
                <acc-icon name="sub-nav-arrow"/>
              </div>
              <ul class="sub-nav collapse" [id]="navRoot.id" data-bs-parent="#sidebar-menu"
                  [class.show]="navRoot.isSelectedInTree()">
                @for (navChild of navRoot.getChildren(); track navChild.id) {
                  <li class="nav-item nav-child">
                    <div class="nav-link" aria-current="page" role="button"
                         [class.active]="navChild.isSelectedInTree()"
                         [attr.aria-controls]="navChild.id"
                         [attr.aria-expanded]="navChild.isSelectedInTree()"
                         [class.collapsed]="!navChild.isSelectedInTree()"
                         (click)="selectAndNavigateByItem(navChild)"
                         (keydown.enter)="selectAndNavigateByItem(navChild)" tabindex="0">
                      <acc-icon [name]="navChild.icon" class="nav-icon"/>
                      <span class="item-name">{{ navChild.title | translate }}</span>
                      @if (navChild.hasChildren()) {
                        <acc-icon name="sub-nav-arrow"/>
                      }
                    </div>
                    <ul class="sub-nav collapse" [id]="navChild.id" data-bs-parent="#sidebar-menu"
                        [class.show]="navChild.isSelectedInTree()">
                      @for (navGrandChild of navChild.getChildren(); track navGrandChild.id) {
                        <li class="nav-item nav-grandchild">
                          <div class="nav-link" [class.active]="navGrandChild.isSelected()"
                               (click)="selectAndNavigateByItem(navGrandChild)"
                               (keydown.enter)="selectAndNavigateByItem(navGrandChild)" tabindex="0">
                            <acc-icon [name]="navGrandChild.icon" class="nav-icon"/>
                            <i class="sidenav-mini-icon">{{ navGrandChild.title | translate | firstChar }}</i>
                            <span class="item-name">{{ navGrandChild.title | translate }}</span>
                          </div>
                        </li>
                      }
                    </ul>
                  </li>
                }
              </ul>
            </li>
          }
        }
      </ul>
    }
  </div>
</div>
